import styled from "styled-components";

export const TestimonialFigure = styled.figure`
  font-family: "Raleway", Arial, sans-serif;
  position: relative;
  float: left;
  overflow: hidden;
  margin: 15px 2%;
  min-width: 220px;
  max-width: 310px;
  min-height: 450px;
  max-height: 500px;
  width: 100%;
  color: #333;
  text-align: left;
  border-radius: 5px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 1.5rem 0.5rem 2rem 0.5rem;
  background-image: linear-gradient(
    -25deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );

  @media (max-width: 768px) {
    min-height: 300px;
    min-width: 220px;
  }
`;

export const TestimonialH1 = styled.h1`
  color: #f7f8fa;
  text-align: center;
  padding: 2rem 0.5rem 2rem 0.5rem;
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const TestimonialIcon = styled.img`
  max-width: 100%;
  height: 100px;
  width: 100px;
  background-color: #000;
  object-fit: contain;
  border-radius: 50%;
  margin-bottom: 15px;
  display: inline-block;
  z-index: 1;
  position: relative;
`;

export const TestimonialBlockQuote = styled.blockquote`
  margin: 0;
  display: block;
  border-radius: 8px;
  position: relative;
  background-color: #fafafa;
  padding: 30px 50px 65px 50px;
  font-size: 0.8em;
  font-weight: 500;
  margin: 0 0 -50px;
  line-height: 1.6em;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  min-height: 278px;
  &::before {
    position: absolute;
    top: 35px;
    left: 20px;
    content: open-quote;
    font-size: 50px;
    opacity: 0.3;
  }

  &::after {
    content: close-quote;
    font-size: 50px;
    opacity: 0.3;
    position: absolute;
    right: 20px;
    bottom: 35px;
  }
`;

export const TestimonialQ = styled.q``;

export const TestimonialAuthor = styled.div`
  margin: 0;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;
  line-height: 1.7;
`;

export const TestimonialH5 = styled.h5`
  opacity: 0.8;
  margin: 0;
  font-weight: 800;
`;

export const TestimonialSpan = styled.span`
  font-weight: 400;
  text-transform: none;
  display: block;
`;
